import { createFileRoute } from '@tanstack/react-router';
import { TransactionsPage } from '../../features/transactions/TransactionsPage.jsx';

export const Route = createFileRoute('/_app/transactions')({ component: TransactionsPage });
